import React, { useContext } from "react";
import { FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { QuestionsContext } from "../../../../../../provider/MyContexts";

export default function ItemSheetsSelect() {
  const { itemSheets, selectedItemSheet, handleChangeItemSheet } = useContext(QuestionsContext);

  const label = "項目一覧シート名";

  return (
    <FormControl
      size="small"
      fullWidth
      sx={{
        marginTop: 2,
      }}
    >
      <InputLabel id="qType-select-label">{label}</InputLabel>
      <Select
        labelId="qType-select-label"
        id="qType-select"
        value={selectedItemSheet}
        onChange={(e: any) => handleChangeItemSheet(e)}
        size="small"
        label={label}
      >
        {itemSheets.map((elm, index) => (
          <MenuItem key={index} value={elm}>{`${elm}`}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
